(function () {
  'use strict';

  function initFaq(section) {
    if (!section || section.dataset.rouxFaqReady === 'true') return;
    section.dataset.rouxFaqReady = 'true';

    var items = Array.from(section.querySelectorAll('[data-roux-faq-item]'));
    var allowMultiple = section.dataset.allowMultiple === 'true';
    var openFirst = section.dataset.openFirst === 'true';

    function getParts(item) {
      return {
        toggle: item.querySelector('[data-roux-faq-toggle]'),
        panel: item.querySelector('[data-roux-faq-panel]')
      };
    }

    function openItem(item) {
      var parts = getParts(item);
      if (!parts.toggle || !parts.panel) return;

      item.classList.add('is-open');
      parts.toggle.setAttribute('aria-expanded', 'true');
      parts.panel.setAttribute('aria-hidden', 'false');
      parts.panel.classList.add('is-open');
      parts.panel.style.maxHeight = parts.panel.scrollHeight + 'px';
    }

    function closeItem(item) {
      var parts = getParts(item);
      if (!parts.toggle || !parts.panel) return;

      item.classList.remove('is-open');
      parts.toggle.setAttribute('aria-expanded', 'false');
      parts.panel.setAttribute('aria-hidden', 'true');
      parts.panel.classList.remove('is-open');
      parts.panel.style.maxHeight = '0px';
    }

    function closeOthers(current) {
      if (allowMultiple) return;
      items.forEach(function (item) {
        if (item !== current) closeItem(item);
      });
    }

    items.forEach(function (item) {
      var parts = getParts(item);
      if (!parts.toggle) return;

      parts.toggle.addEventListener('click', function () {
        var isOpen = parts.toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          closeItem(item);
          return;
        }

        closeOthers(item);
        openItem(item);
      });
    });

    if (openFirst && items.length) {
      openItem(items[0]);
    } else {
      items.forEach(closeItem);
    }

    function refreshHeights() {
      items.forEach(function (item) {
        var parts = getParts(item);
        if (!parts.toggle || !parts.panel) return;

        if (parts.toggle.getAttribute('aria-expanded') === 'true') {
          parts.panel.style.maxHeight = parts.panel.scrollHeight + 'px';
        }
      });
    }

    window.addEventListener('resize', refreshHeights, { passive: true });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();